import { render, staticRenderFns } from "./ModalDialog.vue?vue&type=template&id=ec443e84&scoped=true"
import script from "./ModalDialog.vue?vue&type=script&lang=js"
export * from "./ModalDialog.vue?vue&type=script&lang=js"
import style0 from "./ModalDialog.vue?vue&type=style&index=0&id=ec443e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec443e84",
  null
  
)

export default component.exports